<template>
  <v-container fluid grid-list-md>
    <v-layout v-if="mobileScreen" row wrap>
      <v-flex d-flex xs12 sm12 md12>
        <v-card color="white">
          <v-card-title primary class="title grey ">
            <span><v-icon large color="white">location_on</v-icon></span>{{imprintNavTitle}}
          </v-card-title>
          <!--<v-card-text>{{imprintText}}</v-card-text>-->
          <v-card-text>
          <div v-for="(item, index) in tabelItems" :key="index">
            <div id="inner-paragraph" v-for="(inerItem, inerIndx) in item.allText " :key="inerIndx">
              <p v-for="(textItem, textIndx) in inerItem " :key="textIndx">
                {{textItem.text}}
              </p>
            </div>
          </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="!mobileScreen" row wrap>
      <!--<v-flex d-flex xs4 sm4 md4></v-flex>-->
      <v-flex d-flex xs12 sm12 md12>
        <v-card color="white">
          <v-card-title primary class="title grey ">
            <span><v-icon large color="white">location_on</v-icon></span>{{imprintNavTitle}}
          </v-card-title>
          <!--<v-card-text>{{imprintText}}</v-card-text>-->
          <v-card-text>
            <div v-for="(item, index) in tabelItems" :key="index">
              <div id="inner-paragraph" v-for="(inerItem, inerIndx) in item.allText " :key="inerIndx">
                <p v-for="(textItem, textIndx) in inerItem " :key="textIndx">
                  {{textItem.text}}
                </p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <!--<v-flex d-flex xs4 sm4 md4></v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import * as dataOfImprint from './impressum-private-policy/impressum'
  import { EventBus } from '../events'

  const MOBILE_WIDTH = 900

  export default {
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    data: () => {
      return {
        tabelItems: [],
        window: {
          width: 0
        },
        mobileScreen: false,
      }
    },
    computed: {
        ...mapState('ContactModule', ['imprintText', 'imprintNavTitle']),
        ...mapGetters('ContactModule', {
          languageSelected: 'language',
        }),
    },
    components: {
    },
    mounted(){
      this.updateParagraphs(this.languageSelected)

      EventBus.$on('language', lang => {
        this.updateParagraphs(lang)
      })
    },
    methods: {
      removeLinkToIbNdsFromText(str){
        return str.replace('www.ib-nds.de', '')
      },
      hasLinkToIbNds(str){
        return str.includes('www.ib-nds.de')
      },
      updateParagraphs(val){
        console.log(dataOfImprint.data.de.paragraphs)
        console.log(dataOfImprint.data.en.paragraphs)
        if(val == 'DE'){
          this.tabelItems = dataOfImprint.data.de.paragraphs
        } else {
          this.tabelItems = dataOfImprint.data.en.paragraphs
        }
      },
      handleResize() {
        this.window.width = window.innerWidth
        this.setImgCount()
      },
      setImgCount(){
        if(this.window.width < MOBILE_WIDTH){
          this.mobileScreen = true
        }
        else{
          this.mobileScreen = false
        }
      },
    }
  }
</script>
<style>
  p {
    margin: 5px 0;
  }
  #inner-paragraph {
      margin: 15px 0;
  }
</style>